// @flow
import React, {Component, type Node} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import SiteHeader from '@homeaway/react-site-header';
import breakpoints from '../../utils/breakpoints';
import type {State as ReduxState} from '../../reducers/index';
import './HeaderBar.less';

type StateProps = {
    siteName: string,
    isMobile: boolean,
    fullLocale: string,
    currency: string,
    data: {}
};

type OwnProps = {
    internalTools?: Node
};

type Props = OwnProps & StateProps;

export class HeaderBar extends Component<Props> {
    render() {
        let {
            siteName,
            isMobile,
            internalTools,
            fullLocale,
            currency,
            data
        } = this.props;

        return (
            <SiteHeader
                dataUrl="/serp/api/header"
                siteName={siteName}
                isMobile={isMobile}
                data={data}
                fullLocale={fullLocale}
                internalTools={internalTools}
                currencyCode={currency}
                mobileBreakpoint={breakpoints.SM_MIN}
            />
        );
    }
}

const mapStateToProps = ({
    system: {siteName, isMobile, fullLocale, currency},
    header
}: ReduxState): StateProps => ({
    siteName,
    isMobile,
    fullLocale,
    currency,
    data: header
});

export default compose(connect(mapStateToProps))(HeaderBar);
